"use client";
const e = Object.freeze({
  headerHeight: "60px",
  toastWidth: "min(100%, 520px)"
});
export {
  e as COMPONENT_SIZES
};
